import Vue from 'vue'
import Router from 'vue-router'
import ShortcodeHome from 'LocalComponents/ShortcodeHome.vue'
import Rsvp from 'LocalComponents/Rsvp.vue'
import Survey from 'Core/src/views/Survey.vue'
import Preview from 'Core/src/views/Preview.vue'
import NoSkip from 'Core/src/views/NoSkip.vue'
import Logo from 'Core/src/views/Logo.vue'
import Collect from 'Core/src/views/Collect.vue'
import Submit from 'Core/src/views/Submit.vue'
import Results from 'Core/src/views/Results.vue'
import Profile from 'Core/src/views/Profile.vue'
import Page from 'Core/src/views/Page.vue'
import NotFound from 'Core/src/views/NotFound.vue'

Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,

  mode: 'history',

  routes: [
    {
      path: '/index.html',
      component: ShortcodeHome
    },
    {
      path: '/',
      name: 'home',
      component: ShortcodeHome
    },
    {
      path: '/logo',
      component: Logo
    },
    {
      path: '/p/:alias',
      name: 'page',
      component: Page
    },
    {
      path: '/s/:sid/:qid/:rgqid',
      name: 'survey-g',
      component: Survey
    },
    {
      path: '/s/:sid/:qid',
      name: 'survey',
      component: Survey
    },
    {
      path: '/s/:sid',
      redirect: '/s/:sid/0',
      component: Survey
    },
    {
      path: '/preview/:sid/:qid',
      name: 'preview',
      component: Preview
    },
    {
      path: '/preview/:sid',
      redirect: '/preview/:sid/0',
      component: Preview
    },
    {
      path: '/noskip/:sid/:qid/:rgqid',
      name: 'noskip-g',
      component: NoSkip
    },
    {
      path: '/noskip/:sid/:qid',
      name: 'noskip',
      component: NoSkip
    },
    {
      path: '/noskip/:sid',
      redirect: '/noskip/:sid/0',
      component: NoSkip
    },
    {
      path: '/collect/:cid',
      redirect: '/collect/:cid/0'
    },
    {
      path: '/collect/:cid/:cqid',
      name: 'collect',
      component: Collect
    },
    {
      path: '/submit-err',
      name: 'submit-error',
      component: Submit
    },
    {
      path: '/submit',
      name: 'submit',
      component: Submit
    },
    {
      path: '/results',
      name: 'results',
      component: Results
    },
    {
      path: '/profile/:pid',
      name: 'profile',
      component: Profile
    },
    {
      path: '/:shortcode',
      name: 'shortcode',
      component: ShortcodeHome
    },
    {
      path: '*',
      name: 'not-found',
      component: NotFound
    }
  ]
})

export default router
